<template>
  <div>
    <h1>Editar Pessoa Jurídica</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("pessoas_juridica", ["pessoa_juridica"]),
  },
  methods: {
    ...mapActions("pessoas_juridica", [
      "ActionNewPessoaJuridica",
      "ActionShow",
    ]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "pessoas_juridica_list" });
      }
    },
  },
  async created() {
    await this.ActionNewPessoaJuridica();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
